import { css } from '@/styled-system/css';

export const headerContainerStyles = css.raw({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  width: '100%',
  maxWidth: { base: '100%', md: '768px', lg: '100%', xxl: '1232px' },
  marginTop: { base: 'tight', xl: 'looser' },
  marginBottom: { xxl: 'loose' },
});

export const headingStyles = css.raw({
  xlDown: {
    textStyle: 'heading-sm',
    paddingLeft: 'default',
  },
  xl: {
    textStyle: 'heading-md',
    paddingLeft: 'default',
  },
  xxl: {
    paddingLeft: '0',
  },
});

export const rentalJourneyFiltersContainerStyles = css.raw({
  display: { base: 'none', xxl: 'flex' },
  alignItems: 'center',
  flex: '1',
  minWidth: 0,
  height: '48px',
  overflowX: 'auto',
});

export const filtersSelectorContainerStyles = css.raw({
  display: { base: 'none', xxl: 'block' },
});

export const foldersSelectorContainerStyles = css.raw({
  marginLeft: { base: 'auto', xxl: 'default' },
  marginRight: { base: 'default', xxl: '0' },
});

export const mobileWebFiltersContainer = css.raw({
  display: { base: 'flex', xxl: 'none' },
  width: '100%',
  gap: 'tight',
  alignItems: 'center',
  marginTop: 'tight',
  paddingLeft: 'default',
  overflowX: 'auto',
});
